"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.setCachedOfferQueryVariables = exports.selectedFiltersToQuery = exports.selectedFiltersToGraphQLVariables = exports.selectedFiltersFromQuery = exports.isOfferTypeFilter = exports.isOfferType = exports.isFilterTypeText = exports.isFilterTypeMultiple = exports.hasFilterMultipleValue = exports.getVehicleDisclaimer = exports.getTitle = exports.getSelectedFilterKeysMap = exports.getCachedOfferQueryVariables = exports.convertQueryToGraphQLVariables = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _get = _interopRequireDefault(require("lodash/get"));
var _offersV = require("./offers-v3.config");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var OFFER_QUERY_PARAMS_CACHE_KEY = 'mmc_offr_query_params';
var localStorage = typeof window !== 'undefined' && window.localStorage;
var isOfferTypeFilter = exports.isOfferTypeFilter = function isOfferTypeFilter(key) {
  return key === _offersV.filtersMap.OFFER_TYPE;
};
var isFilterTypeMultiple = exports.isFilterTypeMultiple = function isFilterTypeMultiple(type) {
  return type === _offersV.filtersType.MULTIPLE;
};
var isFilterTypeText = exports.isFilterTypeText = function isFilterTypeText(type) {
  return type === _offersV.filtersType.TEXT;
};
var hasFilterMultipleValue = exports.hasFilterMultipleValue = function hasFilterMultipleValue(value) {
  return typeof value !== 'string';
};
var getSelectedFilterKeysMap = exports.getSelectedFilterKeysMap = function getSelectedFilterKeysMap(selectedFilter) {
  if (!selectedFilter) {
    return {};
  }
  return Object.entries(selectedFilter).reduce(function (keysMap, _ref) {
    var _objectSpread2;
    var key = _ref[0],
      value = _ref[1];
    return value ? _objectSpread(_objectSpread({}, keysMap), {}, (_objectSpread2 = {}, _objectSpread2[key] = value, _objectSpread2)) : keysMap;
  }, {});
};
var getTitle = exports.getTitle = function getTitle(_ref2) {
  var data = _ref2.data,
    queryVariables = _ref2.queryVariables,
    defaultTitle = _ref2.defaultTitle;
  if (!data) {
    return defaultTitle;
  }
  var _ref3 = data || {},
    getOfferV3ListByFilter = _ref3.getOfferV3ListByFilter;
  var _ref4 = getOfferV3ListByFilter || {},
    offerLabel = _ref4.offerLabel;
  var _ref5 = offerLabel || {},
    seeOffersLabel = _ref5.seeOffersLabel,
    seeOffersForVehiclesLabel = _ref5.seeOffersForVehiclesLabel,
    seeOffersNearZipCodeLabel = _ref5.seeOffersNearZipCodeLabel,
    seeOffersForVehiclesNearZipCodeLabel = _ref5.seeOffersForVehiclesNearZipCodeLabel;
  var vehicles = queryVariables.vehicles,
    zipCode = queryVariables.zipCode;
  if (!vehicles && zipCode) return seeOffersNearZipCodeLabel;
  if (vehicles && vehicles.length && !zipCode) return seeOffersForVehiclesLabel;
  if (vehicles && vehicles.length && zipCode) return seeOffersForVehiclesNearZipCodeLabel;
  return seeOffersLabel;
};
var getValueFromQueryParams = function getValueFromQueryParams(filter, queryParamValue) {
  var value = queryParamValue;
  if (!value) {
    return filter.defaultValue;
  }
  if (hasFilterMultipleValue(filter.defaultValue)) {
    var values = value.split(',');
    var valuesMap = values.reduce(function (map, key) {
      var _objectSpread3;
      return _objectSpread(_objectSpread({}, map), {}, (_objectSpread3 = {}, _objectSpread3[key] = true, _objectSpread3));
    }, {});
    if (isOfferTypeFilter(filter.key)) {
      return filter.options.reduce(function (offersTypeValue, option) {
        var _objectSpread4;
        var checked = valuesMap[option.id];
        return checked ? _objectSpread(_objectSpread({}, offersTypeValue), {}, (_objectSpread4 = {}, _objectSpread4[option.name] = true, _objectSpread4)) : offersTypeValue;
      }, filter.defaultValue);
    }
    return _objectSpread(_objectSpread({}, filter.defaultValue), valuesMap);
  }
  return value;
};
var selectedFiltersFromQuery = exports.selectedFiltersFromQuery = function selectedFiltersFromQuery(filters, queryParams) {
  var c = filters.reduce(function (selectedFilters, filter) {
    var _objectSpread5;
    return _objectSpread(_objectSpread({}, selectedFilters), {}, (_objectSpread5 = {}, _objectSpread5[filter.key] = getValueFromQueryParams(filter, queryParams[filter.key]), _objectSpread5));
  }, {});
  return c;
};
var selectedFiltersToArray = function selectedFiltersToArray(selectedFilters, filters, transformers) {
  if (transformers === void 0) {
    transformers = {};
  }
  return filters.reduce(function (query, filter) {
    var selectedValue = selectedFilters[filter.key];
    var transformTypeMultiple = transformers.typeMultiple || function (v) {
      return v;
    };
    var transformTypeSingle = transformers.typeSingle || function (v) {
      return v;
    };
    if (typeof selectedValue !== 'undefined') {
      var _objectSpread6;
      var getMultipleValue = function getMultipleValue() {
        return filter.options.reduce(function (acc, option) {
          return [].concat(acc, [selectedValue[option.name] ? option.queryValue : false]);
        }, []).filter(Boolean);
      };
      var queryValue = isFilterTypeMultiple(filter.type) ? transformTypeMultiple(getMultipleValue(), filter) : transformTypeSingle(selectedValue, filter);
      return _objectSpread(_objectSpread({}, query), {}, (_objectSpread6 = {}, _objectSpread6[filter.key] = queryValue, _objectSpread6));
    }
    return query;
  }, {});
};
var selectedFiltersToQuery = exports.selectedFiltersToQuery = function selectedFiltersToQuery(selectedFilters, filters, filterKey) {
  var out = {};
  Object.keys(selectedFilters).forEach(function (key) {
    out[key] = selectedFilters[key];
  });
  var query = selectedFiltersToArray(out, filters, {
    typeMultiple: function typeMultiple(v) {
      return v.join(',');
    }
  });
  return query;
};
var isUTM = function isUTM(queryParam) {
  for (var filter in _offersV.filtersMap) {
    if (_offersV.filtersMap[filter] === queryParam) {
      return false;
    }
  }
  return true;
};
var convertQueryToGraphQLVariables = exports.convertQueryToGraphQLVariables = function convertQueryToGraphQLVariables(query, filters) {
  var variables = {};
  Object.keys(query).forEach(function (key) {
    if (key === 'datasetName') {
      variables[key] = query[key];
      return;
    }
    if (isUTM(key)) return;
    var target = filters.find(function (filter) {
      return filter.key === key;
    });
    if (target) {
      var keyType = target.type;
      var newKey = key === 'provinceMapList' ? 'zipCode' : key;
      var value = ['zipCode', 'region'].includes(key) ? [query[key]] // as backend expects zipCode value to be an array
      : query[key];
      variables[newKey] = keyType === 'multiple' ? query[key].split(',') : value;
    }
  });
  //Preview future offers in test environments
  if (typeof window !== 'undefined') {
    if (query && (query.startDate || query.endDate)) {
      var host = window.location.hostname;
      if (host.includes(".dev.") || host.includes(".uat.") || host.includes("localhost")) {
        if (query.startDate) variables.startDate = query.startDate;
        if (query.endDate) variables.endDate = query.endDate;
      }
    }
  }
  return variables;
};
var selectedFiltersToGraphQLVariables = exports.selectedFiltersToGraphQLVariables = function selectedFiltersToGraphQLVariables(selectedFilters, filters) {
  var variables = selectedFiltersToArray(selectedFilters, filters, {
    typeMultiple: function typeMultiple(value) {
      return (
        // undefined resets the value in GraphQL
        // giving the default offers list
        value.length ? value : undefined
      );
    }
  });
  return variables;
};
var getVehicleDisclaimer = exports.getVehicleDisclaimer = function getVehicleDisclaimer(vehicle) {
  return (0, _get["default"])(vehicle, 'offers[0].legalTextImage');
};
var getCachedOfferQueryVariables = exports.getCachedOfferQueryVariables = function getCachedOfferQueryVariables() {
  if (!localStorage || !localStorage.getItem(OFFER_QUERY_PARAMS_CACHE_KEY)) {
    return {};
  }
  return JSON.parse(localStorage.getItem(OFFER_QUERY_PARAMS_CACHE_KEY));
};
var setCachedOfferQueryVariables = exports.setCachedOfferQueryVariables = function setCachedOfferQueryVariables(data) {
  if (!localStorage) {
    return;
  }
  if (data) {
    localStorage.setItem(OFFER_QUERY_PARAMS_CACHE_KEY, JSON.stringify(data));
  }
};
var isOfferType = exports.isOfferType = function isOfferType(offer, typeKey) {
  var _offer$offerType, _OFFER_TYPES$typeKey;
  var OFFER_TYPES = {
    finance: ['finance', 'financement'],
    lease: ['lease', 'location']
  };
  var type = offer == null || (_offer$offerType = offer.offerType) == null ? void 0 : _offer$offerType.toLowerCase();
  return (_OFFER_TYPES$typeKey = OFFER_TYPES[typeKey]) == null ? void 0 : _OFFER_TYPES$typeKey.includes(type);
};